import React from "react";
import { Button } from "../v2/buttons";
import { PlusIcon } from "../v2/icons";
import AgencySubtitle from "../AgencySubtitle";
import useSupportFabLift from "../../../hooks/useSupportFabLift";

// My Agency V2 mobile chrome (ARTBOARD-SPEC boards 1l/2j): header block
// with the 21px/700 page title, and the context-sensitive invite action
// as a pinned bottom FAB (full-width primary + SYM-01, shadow
// 0 8px 24px rgba(34,131,255,.4)).
//
// PRESENTATION-ONLY restyle (Brief Rule 6): handleInviteClick dispatches
// per activeTab to the exact same callbacks as the previous "+ Invite"
// header button — zero wiring changes. FAB labels per artboards
// (1l "Invite agent", 2j "Add player", 4a "Add partner"; Staff keeps the
// existing "Invite staff" wording — no artboard exists for it).
const FAB_LABELS = {
  agents: "Invite agent",
  players: "Add player",
  staff: "Invite staff",
  partners: "Add partner",
};

const AgencyProfileMobileHeader = ({
  activeTab,
  onInviteAgent,
  onInvitePartner,
  onInvitePlayer,
  onInviteStaff,
  // F-2 (board 1l): optional subtitle data from the page's tab-counts
  // fetch; absent → no subtitle (presentation-only addition).
  agencyName = null,
  memberCount = null,
}) => {
  const handleInviteClick = () => {
    if (activeTab === "agents") {
      onInviteAgent();
    } else if (activeTab === "partners") {
      onInvitePartner();
    } else if (activeTab === "players") {
      onInvitePlayer && onInvitePlayer();
    } else if (activeTab === "staff") {
      // TP-Coach-Mandate: staff tab reaches this header only when the
      // STAFF_MANDATE_ENABLED tab exists, so no extra flag check needed.
      onInviteStaff && onInviteStaff();
    }
  };

  const showFab =
    activeTab === "agents" ||
    activeTab === "partners" ||
    activeTab === "players" ||
    (activeTab === "staff" && onInviteStaff);

  // The invite bar is fixed to the bottom edge (bottom-5 + ~50px button,
  // z-30) and sat on top of the app-wide support button (z-20), making
  // support unreachable on this page. Declare the bar's footprint so the
  // support button rises above it (64px clears bottom-5 + button height
  // with a small gap). This component only mounts on mobile (AgencyProfile
  // gates it behind isMobile), so desktop is untouched.
  useSupportFabLift(showFab ? 64 : 0);

  return (
    <>
      <div className="px-4 pt-4 pb-2">
        <h1 className="text-[21px] font-bold text-[#0F172A] tracking-[-.01em]">
          My Agency
        </h1>
        <AgencySubtitle name={agencyName} memberCount={memberCount} mobile />
      </div>
      {showFab && (
        <div className="fixed left-4 right-4 bottom-5 z-30">
          <Button mobile fab icon={<PlusIcon size={16} />} onClick={handleInviteClick}>
            {FAB_LABELS[activeTab] || "Invite"}
          </Button>
        </div>
      )}
    </>
  );
};

export default AgencyProfileMobileHeader;
